import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OauthComponent } from './oauth.component';

const routes: Routes = [
  { path: 'oauth', component: OauthComponent, data: { title: 'Oauth' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})

export class OauthRouteModule { }
